import React, {useCallback, useState} from 'react';
import {style,} from "../helpers/style";
import {Box, Fade, Modal, Typography} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import {input, sip} from "../translate";
import CloseIcon from "@mui/icons-material/Close";
import Cookies from "js-cookie";
import Api from "../Api";
import {sipCreateRequest} from "../store/actions/sip";
import Account from "../helpers/Account";
import {useDispatch} from "react-redux";
import {useLocation} from "react-router-dom";
import qs from "query-string";

function AddSipShort({open, count,isMob, setOpen,setGlobalOpen}) {
    const [list, setList] = useState(new Array(+count).fill({note: '', short: ''}))
    const location = useLocation()
    const query = qs.parse(location.search, {arrayFormat: 'comma'});
    const dispatch = useDispatch();
    const handleAdd = async (ev) => {
        await dispatch(sipCreateRequest(count,list, Account.getUrsToken(), isMob, Cookies.get("sip") || query.limit || 10, query.page || 1, query.search || '', '', query.sortBy || '', query.sortOrder || ''))
        setOpen(false)
        setGlobalOpen(false)
    }

    let handleChangeSingle = useCallback((key, index, value) => {
        setList(prev =>
            prev.map((item, i) =>
                i === index ? { ...item, [key]: value } : item
            )
        );
    }, []);
    const handleGenerateSingle = useCallback(async (index) => {
            const maxShortElement = list.reduce((max, obj) => (obj.short > max.short ? obj : max), list[0]);
            if (maxShortElement.short) {
                const {data} = await Api.generate(+maxShortElement.short + 1)
                handleChangeSingle('short',index, data.counter)
                handleChangeSingle('note',index, data.counter)
            } else {
                const {data} = await Api.generate(11)
                handleChangeSingle('short',index, data.counter)
                handleChangeSingle('note',index, data.counter)
            }
    }, [list])
    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={() => setOpen(false)}
            closeAfterTransition
            slots={{backdrop: Backdrop}}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box sx={{...style, width: window.innerWidth > 600 ? 600 : window.innerWidth,}}>
                    <div className="d-flex flex-row justify-content-between">
                        <Typography id="transition-modal-title" variant="h6" component="h2">
                            {sip.generate_btn[+localStorage.getItem('atsLang') || 1]}
                        </Typography>
                        <span style={{cursor: 'pointer'}} onClick={() => setOpen(false)}>
                            <CloseIcon/>
                        </span>
                    </div>
                    <form onSubmit={handleAdd} id="transition-modal-description sip_content" style={{marginTop: 20}}>
                        {list.map((item, index) => (
                            <div className="d-flex justify-content-between">
                                <label className="count" style={{margin: '5px 0', width: 270}}>
                                        <span>
                                            {sip.note[+localStorage.getItem('atsLang') || 1]} :
                                        </span>
                                    <input type="text" value={item.note}
                                           onChange={(ev) => handleChangeSingle('note', index, ev.target.value)}/>
                                </label>
                                <div className="count" style={{margin: '5px 0', width: 220}}>
                                    <div className="d-flex justify-content-end align-items-center">
                                        <div
                                            className="adminLoginBtn m-0"
                                            onClick={() => handleGenerateSingle(index)}>
                                            {sip.generate[+localStorage.getItem('atsLang') || 1]}
                                        </div>
                                    </div>

                                    <input
                                        type="number"
                                        value={item.short}
                                        onChange={(ev) => handleChangeSingle('short', index, ev.target.value)}
                                    />
                                </div>
                            </div>
                        ))}

                        <div style={{marginTop:20}} className="addBtnBig d-flex justify-self-between" onClick={handleAdd}>
                            {sip.add_btn[+localStorage.getItem('atsLang') || 1]}
                        </div>

                    </form>
                </Box>
            </Fade>
        </Modal>
    );
}

export default AddSipShort;